var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesheets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.445 23.222A22.222 22.222 0 1 0 12.11 42.467l11.111-19.245h22.223Z",
    fill: "#FC868B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.313 32.53A22.222 22.222 0 1 0 37.889 7.533L26.778 26.778 5.313 32.53Z",
    fill: "#2EBCFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.221 45.444c12.274 0 22.223-9.95 22.223-22.223 0-5.23-1.807-10.039-4.832-13.835a22.128 22.128 0 0 0-13.835-4.831c-12.273 0-22.222 9.949-22.222 22.222 0 5.23 1.807 10.04 4.831 13.835a22.128 22.128 0 0 0 13.835 4.832Z",
    fill: "#2D6388"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.719 7.303c.646-.63 1.33-1.22 2.05-1.768.227.056.445.161.639.316L26.58 18.796c1.82 1.456 1.946 4.192.297 5.84-1.649 1.647-4.387 1.521-5.845-.297L8.075 8.181a1.651 1.651 0 0 1-.356-.878Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheets);
export default __webpack_public_path__ + "static/media/Timesheets.adbe3f113af0ab3bff8b1a96ce6e3aea.svg";
export { ForwardRef as ReactComponent };